@for (date of dates; track date) {
  <div>
    <div class="d-flex align-items-center mb-3">
      <span class="mr-3 date">{{ date | date : 'EEEE':'de' }}, {{ date | date : 'dd.MM.yyyy' }}</span>
      <p-button [disabled]="loading" [outlined]="true" size="small" [rounded]="true" class="mr-3" label="ABHOLPLAN"
                (click)="getPickupSchedule(date)"></p-button>
    </div>
  </div>
}
